import template from './lidAuth.template.html';

export default {
  bindings: {
    onFinish: '&'
  },
  controller: class controller {
    constructor($mdDialog) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      this.initialize = () => {
        $mdDialog
          .show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            multiple: true,
            controller() {
              const self = this;
              self.token = '';
              self.trackingCode = '';

              self.confirm = () => {
                $mdDialog.hide({ token: self.token, trackingCode: self.trackingCode });
              };
              self.cancel = () => {
                $mdDialog.hide(false);
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      this.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
